<app-navigation-layout [hideHeader]='true' [hideMenu]="true">
  <span main-container>
    <h3>{{ 'Refund Card' | translate}}</h3>
    <div class="container">
      <div class="row justify-content-center align-items-center">
        <div class="col-12">
          <h2 *ngIf="showTakeCardMessage">{{ 'Please take your Card' | translate}}</h2>
          <h2 *ngIf="showInsertCardMessage">{{ 'Please insert your Card' | translate}}</h2>
          <app-login-payment *ngIf="showLoginForm" (eventBack)="onBack()" (eventLoggedIn)="onNext()"
            [showGuestRegister]="false" [fullSize]="true" [showBack]="true" [showRegistrationUrl]="false"
            [email]="scanPartnerCodeInfo?.partner?.email" [readOnlyEmail]="true" [showRememberMe]="false">
          </app-login-payment>
          <h2 *ngIf="showBalanceMessage && isCardBalance">{{ messageBalance | translate:{ cardBalance: cardBalance, guestCardPrice:
            guestCardPrice } }}</h2>
          <h2 *ngIf="showBalanceMessage && isAvailableAmount">{{ messageAvailableAmount | translate:{ availableAmount: availableAmount } }}
          </h2>
          <h2 *ngIf="showPleaseWaitMessage">{{ 'Please wait..' | translate}}</h2>
        </div>
      </div>
    </div>
  </span>
  <span navigation-container>
    <app-backward-forward *ngIf="!showLoginForm" (backwardClick)="onBack()" [hideNext]="hideNext" (forwardClick)="onNext()">
    </app-backward-forward>
  </span>
</app-navigation-layout>
